module.exports = __webpack_public_path__ + "img/Pista_03_2.5e26d2bb.png";